import { Box, Text } from '@radix-ui/themes';

const CircleProgress = ({
    progress = 0,
    size = 36,
    strokeWidth = 3,
    color = '#0091ff',
    label,
    labelSize = '1',
    selected = false
}) => {
    // Calculate radius based on size and stroke width to prevent clipping
    const radius = (size / 2) - (strokeWidth + 1);

    // Calculate circumference of the circle
    const circumference = 2 * Math.PI * radius;

    // Calculate the dash array based on the progress percentage and circumference
    const progressValue = (progress * circumference) / 100;
    const dashArray = `${progressValue} ${circumference}`;

    return (
        <Box
            position="relative"
            style={{
                width: size,
                height: size,
                cursor: 'pointer',
            }}
        >
            <div style={{
                overflow: 'hidden',
                width: size,
                height: size,
                position: 'absolute',
                top: 0,
                left: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke="#e9ecef"
                        strokeWidth={strokeWidth}
                    />
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke={selected ? '#ff8533' : color}
                        strokeWidth={strokeWidth}
                        strokeDasharray={dashArray}
                        transform={`rotate(-90 ${size / 2} ${size / 2})`}
                    />
                </svg>
                {label !== undefined && label !== null && (
                    <Text
                        size={labelSize}
                        weight="bold"
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            pointerEvents: 'none'
                        }}
                    >
                        {label}
                    </Text>
                )}
            </div>

        </Box>
    );
};

export default CircleProgress;
